import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { canDeactivateGuard } from './core/guards/desactivate.guard';
import { loginGuard } from './core/guards/login.guard';
import { AppRoutes, Paths } from './core/routes/route.paths';

export const routes: Routes = [
  {
    path: Paths.Welcome,
    loadComponent: () => import('./features/welcome/welcome.component').then((m) => m.WelcomeComponent),
    canActivate: [authGuard],
  },
  {
    path: Paths.Auth.root,
    canActivate: [loginGuard],
    loadChildren: () => import('./core/routes/auth.routes').then((m) => m.AuthRoutes),
  },
  {
    path: Paths.Customers.root,
    canActivate: [authGuard],
    loadChildren: () => import('./core/routes/customers.routes').then((m) => m.CustomersRoutes),
  },
  {
    path: Paths.Validator.root,
    canActivate: [authGuard],
    loadChildren: () => import('./core/routes/validator.routes').then((m) => m.ValidatorRoutes),
  },
  {
    path: Paths.DashboardCourrier,
    loadComponent: () =>
      import('./features/dashboard-courrier/dashboard-courrier.component').then((m) => m.DashboardCourrierComponent),
    canActivate: [authGuard],
  },
  {
    path: Paths.VirtualPrinter,
    loadComponent: () =>
      import('./features/virtual-printer/virtualPrinter.component').then((m) => m.VirtualPrinterComponent),
    canActivate: [authGuard],
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: Paths.Report.root,
    canActivate: [authGuard],
    loadChildren: () => import('./core/routes/report.routes').then((m) => m.ReportRoutes),
  },
  {
    path: Paths.Search,
    loadComponent: () => import('./features/search/search.component').then((m) => m.SearchComponent),
    canActivate: [authGuard],
  },
  {
    path: Paths.GenerixEmails,
    loadComponent: () =>
      import('./features/generix-emails/generix-emails.component').then((m) => m.GenerixEmailsComponent),
    canActivate: [authGuard],
  },

  {
    path: Paths.SuivreEnvois,
    loadComponent: () =>
      import('./features/suivre-envois/suivre-envois.component').then((m) => m.SuivreEnvoisComponent),
    canActivate: [authGuard],
  },
  {
    path: Paths.AccesGed.root,
    loadChildren: () => import('./core/routes/acces-ged.routes').then((m) => m.AccessGedRoutes),
    canActivate: [authGuard],
  },
  {
    path: Paths.MiseEnGed,
    loadComponent: () =>
      import('./features/mise-en-ged/mise-en-ged/mise-en-ged.component').then((m) => m.MiseEnGedComponent),
    canActivate: [authGuard],
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: Paths.InputValidator,
    loadComponent: () =>
      import('./features/input-validator/input-validator.component').then((m) => m.InputValidatorComponent),
    canActivate: [authGuard],
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: Paths.ValiderPlis,
    loadComponent: () =>
      import('./features/new-validator/validator-tabs.component').then((m) => m.ValidatorTabsComponent),
    canActivate: [authGuard],
  },
  {
    path: `${Paths.ValiderPlis}/:id/sign`,
    loadComponent: () => import('./features/new-validator/signature.component').then((m) => m.SignatureComponent),
    canActivate: [authGuard],
  },
  {
    path: Paths.ValidatePendingDocuments,
    loadComponent: () =>
      import('./features/input-validator/input-validator.component').then((m) => m.InputValidatorComponent),
    canActivate: [authGuard],
    data: { mode: 'validation' },
  },
  {
    path: Paths.VirtualPrinterNew,
    loadComponent: () =>
      import('./features/virtual-printer-new/virtual-printer-new.component').then((m) => m.VirtualPrinterNewComponent),
    canActivate: [authGuard],
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: Paths.Configuration.root,
    canActivate: [authGuard],
    loadChildren: () => import('./core/routes/configuration.routes').then((m) => m.ConfigurationRoutes),
  },
  {
    path: Paths.Supervision.root,
    canActivate: [authGuard],
    loadChildren: () => import('./core/routes/supervision.routes').then((m) => m.SupervisionRoutes),
  },
  {
    path: Paths.GestionBaseDonnees.root,
    canActivate: [authGuard],
    loadChildren: () => import('./core/routes/database-management.routes').then((m) => m.DatabaseManagementRoutes),
  },
  {
    path: Paths.ConfigGeneral.root,
    canActivate: [authGuard],
    loadChildren: () => import('./core/routes/configgeneral.routes').then((m) => m.ConfigGeneralRoutes),
  },
  {
    path: Paths.Clients.root,
    canActivate: [authGuard],
    loadChildren: () => import('./core/routes/customer-accounts.routes').then((m) => m.ClientsRoutes),
  },
  {
    path: Paths.Information,
    loadComponent: () => import('./features/information/information.component').then((m) => m.InformationComponent),
    canActivate: [authGuard],
  },
  {
    path: Paths.Admin.root,
    canActivate: [authGuard],
    loadChildren: () => import('./core/routes/admin.routes').then((m) => m.AdminRoutes),
  },
  {
    path: Paths.Sso.root,
    canActivate: [authGuard],
    loadChildren: () => import('./core/routes/sso.routes').then((m) => m.SsoRoutes),
  },
  {
    path: Paths.ConfigurationClient.root,
    canActivate: [authGuard],
    loadChildren: () => import('./core/routes/config-clients.routes').then((m) => m.ConfigClients),
  },
  {
    path: Paths.Profil,
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/profil/edit-password/edit-password.component').then((m) => m.EditPasswordComponent),
  },
  {
    path: Paths.VirtuarlPrinterApp.root,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./core/routes/virtual-printer-application.routes').then((m) => m.VirtualPrinterApplicationRoutes),
  },
  {
    path: 'verify',
    loadComponent: () => import('./features/verification/verification.component').then((m) => m.VerificationComponent),
  },
  {
    path: Paths.Error,
    loadComponent: () => import('./features/error/error.component').then((m) => m.ErrorComponent),
  },
  {
    path: '',
    redirectTo: AppRoutes.Auth.root,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: AppRoutes.Error,
    pathMatch: 'full',
  },
];
